import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const ReferralHandler = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      // Salvar o código no localStorage
      window.localStorage.setItem('overpixel_referral_code', code);
      
      // Feedback visual
      toast.success('Código de convite aplicado! Crie sua conta ou faça login para ganhar bônus.', {
        duration: 5000,
        icon: '🎁'
      });

      // Redirecionar para a página inicial ou de cadastro
      // Se o usuário já estiver logado, o AuthContext vai processar isso
      navigate('/', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-cyan-400 font-bold">Processando convite...</p>
      </div>
    </div>
  );
};

export default ReferralHandler;
